import React, { Component, useEffect, useState } from "react"
// import { Flipper } from "react-flip-toolkit"
// import DropdownContainer from "./DropdownContainer"
// import { Icon, DropdownSection, Heading } from "./DropdownContents/Components.js"
import { BiCategoryAlt, BiChevronLeft, BiChevronRight } from "react-icons/bi";
import * as rsuite from 'rsuite'
import styled from "styled-components"
import * as General from '../Business/General/General.js'
import { useNavigate } from 'react-router-dom'
import UserProperty from "./UserProperty.js"
import LogOut from "./LogOut.js"
import { BasketContext } from "../Business/Context/BasketContext.js";
import * as BiIcon from "react-icons/bi"


const NavbarItemTitle = styled.button`
  background: transparent;
  border: 0;
  font-weight: bold;
  font-size: 13px;
  padding: 2rem 1.5rem 1.2rem 1.5rem;
  text-color: secondary;
  display: flex;
  justify-content: center;
  transition: opacity 250ms;
  cursor: pointer;
  /* position above the dropdown, otherwise the dropdown will cover up the bottom sliver of the buttons */
  position: sticy;
  z-index: 200;
  &:hover, &:focus {
    opacity: 0.7;
    outline:none;
  }
`
const NavbarItemEl = styled.li`
   position: relative;

`


const DropdownSlot = styled.div`
  position: absolute;
  left: 40%;
  transform: translateX(-50%);
  perspective: 1500px;
  
`

//#region Product



const SubProductsList = styled.ul`
li {
  display: flex;
  margin-bottom: 1rem;
}
h3 {
  margin-right: 1rem;
  width: 29rem;
  display: block;
}
a {
  color: var(--dark-grey);
}
`

const ProductsSection = styled.ul`
// li {
//   display: flex;
// }
  overflow-y: auto !important;
	scroll-snap-type: y mandatory !important;
	overflow-x: hidden;
  max-height: 70vh !important;
`
//#endregion
const MobNavbar = (props) => {
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false)
    const [SubMenu, setSubMenu] = React.useState("")
    const [ProductGroup, setProductGroup] = React.useState([])
    const [BasketItemCount, setBasketItemCount] = React.useState(0)

    const [scrolling, setScrolling] = useState(false);

    const NavbarEl = styled.nav`
    margin: auto;
    position: fixed;
    z-index:100;
    width:100%
    `

    const { basketRef, count, setCount } = React.useContext(BasketContext);

    // وقتی میخوای count رو بگیری و badge رو آپدیت کنی:
    const updateBasketCount = async () => {
        basketRef.current.GetCount().then(count => setBasketItemCount(count));

    };




    useEffect(() => {
        updateBasketCount();

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [updateBasketCount]);

    const handleScroll = () => {
        if (window.scrollY > 20) {
            setScrolling(true);
        } else {
            setScrolling(false);
        }
    };











    const NavigatePage = (url) => {
        navigate(url)

    }



    return (

        <NavbarEl className={scrolling ? 'ScroolNavbar' : 'ScroolNavbar'}>
            <rsuite.Row className="pe-3 ps-3 pb-2">
                <rsuite.Col xs={6}>
                    <BiCategoryAlt onClick={() => (setOpen(true), setSubMenu(""), setProductGroup([[]]))} className="Cursor" style={{ width: 30, height: 30, marginTop: 20 }} />
                </rsuite.Col>
                <rsuite.Col xs={18}>

                    <img onClick={() => (NavigatePage("/"), setOpen(false))} title="خانه" className="Cursor" src="../../../../../../assets/images/Logo.png" style={{ float: "inline-end", width: 30, height: 30, marginTop: 20 }} />
                    <div style={{ float: "inline-end", marginTop: 15 }}>
                        <UserProperty ></UserProperty>
                        <LogOut></LogOut>

                        <rsuite.Badge color='green' right content={count || false}>
                            <BiIcon.BiBasket onClick={() => { basketRef.current?.Show(); updateBasketCount() }} className="fw-bold Font25 m-2" />
                        </rsuite.Badge>
                    </div>
                </rsuite.Col>
            </rsuite.Row>
            {/*  */}

            <rsuite.Drawer size="full" placement="top" open={open} onClose={() => setOpen(false)}>
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title className=" Font13">
                        {SubMenu == "" ?
                            <b> منو اصلی </b>
                            : SubMenu == "Product" ?
                                <b> محصولات  </b>
                                : SubMenu == "Brand" ?
                                    <b> برند  </b>
                                    :
                                    <b>{SubMenu.split("_")[1]}</b>
                        }
                    </rsuite.Drawer.Title>
                    <rsuite.Drawer.Actions>
                        {SubMenu == "" ?
                            <img className="Cursor" src="../../../../../../assets/images/Logo.png" onClick={() => (NavigatePage("/"), setOpen(false))} style={{ width: 30, height: 30, marginTop: 8 }} />
                            : SubMenu == "Product" ?
                                <BiChevronRight className="Font17 mt-2 float-start Cursor" onClick={() => setSubMenu("")} />
                                : SubMenu == "Brand" ?
                                    <BiChevronRight className="Font17 mt-2  float-start Cursor" onClick={() => setSubMenu("")} />
                                    :
                                    <BiChevronRight className="Font17 mt-2 float-start Cursor" onClick={() => setSubMenu("Product")} />


                        }


                    </rsuite.Drawer.Actions>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <rsuite.Row>
                        {SubMenu == "" ?
                            <rsuite.Col xs={24}>
                                <p className="Cursor" onClick={() => setSubMenu("Product")}>
                                    محصولات <BiChevronLeft className="Font17 float-start" />
                                </p>
                                <rsuite.Divider />
                                <p className="Cursor" onClick={() => setSubMenu("Brand")}>
                                    برند <BiChevronLeft className="Font17 float-start" />
                                </p>
                                <rsuite.Divider />

                                <p className="Cursor" onClick={() => NavigatePage("/MotorSuggestion")}>
                                    پیشنهاد موتور برق
                                </p>
                                <rsuite.Divider />

                                <p className="Cursor" onClick={() => NavigatePage("/CompareProduct")}>
                                    مقایسه محصولات
                                </p>

                                <rsuite.Divider />
                                <p className="Cursor" onClick={() => NavigatePage("/AboutUs")}>
                                    درباره ما
                                </p>
                                <rsuite.Divider />
                                <p className="Cursor" onClick={() => NavigatePage("/ContactUs")}>
                                    تماس با ما
                                </p>
                                <rsuite.Divider />
                            </rsuite.Col>
                            : SubMenu == "Product" ?
                                <rsuite.Col xs={24}>
                                    {props.value[0].map((group) =>
                                        <>
                                            <p className="Cursor" onClick={() => (setSubMenu("ُSubProduct_" + group.title), setProductGroup(group))}>
                                                {group.title} <BiChevronLeft className="Font17 float-start" />

                                            </p>
                                            <rsuite.Divider />
                                        </>


                                    )}
                                    {/* </rsuite.Accordion> */}
                                    <a onClick={() => NavigatePage("/ParentGroup")} className=" Cursor fw-bold FarmAsan-text-success">
                                        <p className="mt-3 pt-2 Cursor Hover  text-start fw-bold">
                                            مشاهده تمام دسته بندی محصولات ...
                                        </p>
                                    </a>
                                </rsuite.Col>
                                : SubMenu == "Brand" ?
                                    <rsuite.Col xs={24}>
                                        {props.value[1].map(brand => (
                                            <>
                                                <p onClick={() => NavigatePage(brand.id != -1 ? "/ProductBrand/" + General.toSlug(brand.title) + "/" + brand.id : "/Brand")} className={brand.id != -1 ? "Cursor Hover" : "Cursor Hover Font13 text-start fw-bold"}>
                                                    <rsuite.Avatar className={brand.id != -1 ? "ms-2" : "hide"} size="sm" circle src={General.ApiPhotoRoute() + 'Content/Images/BrandPhoto/' + brand.id + '.jpg'} alt={brand.title} />
                                                    {brand.title}
                                                </p>
                                                <rsuite.Divider className={brand.id != -1 ? "hr-Fade" : 'hide'} />
                                            </>

                                        ))}
                                    </rsuite.Col>
                                    :
                                    <rsuite.Col xs={24}>
                                        {ProductGroup.children.map((child) =>
                                            <>

                                                <p className="Cursor Hover"
                                                    // onClick={() => NavigatePage("/Product/" +
                                                    //     General.toSlug(ProductGroup.title) + "/" +
                                                    //     General.toSlug(child.title) == General.toSlug(ProductGroup.title)
                                                    //     ? General.toSlug(child.title)
                                                    //     : General.toSlug(child.title).replace(General.toSlug(ProductGroup.title), "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") +
                                                    //     "/" + ProductGroup.id + "/" + child.id)}>
                                                    onClick={() => {
                                                        const groupSlug = General.toSlug(ProductGroup.title, { latin: true });
                                                        const childSlug = General.toSlug(child.title, { latin: true });

                                                        const childPart = (groupSlug === childSlug)
                                                            ? childSlug
                                                            : childSlug.replace(groupSlug, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "");

                                                        NavigatePage(`/Product/${groupSlug}/${childPart}/${ProductGroup.id}/${child.id}`);
                                                    }}>
                                                    <rsuite.Avatar className="ms-2" size="sm" circle src={General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + ProductGroup.id + '' + ProductGroup.photoTag + '.jpg'} alt={General.toSlug(ProductGroup.title)} />
                                                    {child.title}
                                                </p>
                                                <rsuite.Divider />
                                            </>


                                        )}

                                    </rsuite.Col>


                        }

                    </rsuite.Row>

                </rsuite.Drawer.Body>
            </rsuite.Drawer>
        </NavbarEl>

    )

}

export default MobNavbar;
